<div class="report-create-report">
    <app-loader *ngIf="isLoading"></app-loader>

    <div class="create-report-type">
        <h2 class="title">Create Report</h2>
        <div class="custom-stepper">
            <div class="step" [class.active]="step() === 1" [class.done]="step() !== 1">
                <div class="circle"><mat-icon>check</mat-icon></div>
                <div class="label">Initiate</div>
            </div>
            <div class="line"></div>
            <div class="step" [class.active]="step() === 2">
                <div class="circle">
                    <div class="initial-center">2</div>
                </div>
                <div class="label">Generate</div>
            </div>
            <div class="line"></div>
            <div class="step" [class.active]="step() === 3">
                <div class="circle">
                    <div class="initial-center">3</div>
                </div>
                <div class="label">Review</div>
            </div>
            <div class="line"></div>
            <div class="step" [class.active]="step() === 4">
                <div class="circle">
                    <div class="initial-center">4</div>
                </div>
                <div class="label">Approved</div>
            </div>
        </div>
    </div>
    <div class="report-form">
        <form [formGroup]="options">
            <div class="form-container">
                <app-searchable-dropdown label="Report Type" [items]="reportTypes()" bindLabel="reportTypeName"
                    bindValue="id" placeholder="Select Report Type"
                    errorMessage="{{validationMessages.CREATE_GENERATE_REPORT.REPORT_TYPE_REQUIRED }}"
                    formControlName="reportType">
                </app-searchable-dropdown>

                <div>
                    <label for="projectID">Project Number</label>
                    <input type="number" numbersOnly inputmode="numeric" id="projectID" formControlName="projectID"
                        placeholder="Enter Project Number">
                    <div class="error-message"
                        *ngIf="options.get('projectID')?.touched && options.get('projectID')?.invalid">
                        {{ validationMessages.CREATE_GENERATE_REPORT.PROJECT_ID_REQUIRED }}
                    </div>
                </div>
                
                <app-searchable-dropdown label="Client Name" [items]="clients()" bindLabel="clientName"
                    bindValue="clientId" placeholder="Select Client" errorMessage="Client is required"
                    formControlName="clientName">
                </app-searchable-dropdown>

                <app-searchable-dropdown label="Site/Location Name" [items]="locations()" bindLabel="locationName"
                    bindValue="locationId" placeholder="Select Site/Location Name"
                    errorMessage="{{ validationMessages.CREATE_GENERATE_REPORT.LOCATION_REQUIRED }}"
                    formControlName="sitelocationname">
                </app-searchable-dropdown>

                <app-searchable-dropdown label="State" [items]="satates()" bindLabel="stateName" bindValue="stateId"
                    placeholder="Select State"
                    errorMessage="{{ validationMessages.CREATE_GENERATE_REPORT.STATE_REQUIRED }}"
                    formControlName="stateName">
                </app-searchable-dropdown>

                <div>
                    <label for="reportName">Report Name/Title</label>
                    <input type="text" id="reportName" formControlName="reportName"
                        placeholder="Enter Report Name/Title">
                    <div class="error-message"
                        *ngIf="options.get('reportName')?.touched && options.get('reportName')?.invalid">
                        {{ validationMessages.CREATE_GENERATE_REPORT.REPORT_NAME_REQUIRED }}
                    </div>
                </div>

                <div>
                    <label for="reportMonth">Report Month</label>
                    <app-month-picker id="reportMonth" formControlName="reportMonth"></app-month-picker>
                    <div class="error-message"
                        *ngIf="options.get('reportMonth')?.touched && options.get('reportMonth')?.invalid">
                        {{ validationMessages.CREATE_GENERATE_REPORT.REPORT_MONTH_REQUIRED }}
                    </div>
                </div>
            </div>

            <br>
            <div>
                <label for="additionalNotes">Additional Notes</label>
                <textarea id="additionalNotes" formControlName="additionalNotes"
                    placeholder="Enter any additional notes here" rows="5" class="notes-textarea"></textarea>
            </div>
        </form>
    </div>
    <div class="page-action">
        <button type="button" class="aecom_btn" (click)="onCancel()">Cancel</button>
        <button type="button" class="aecom_btn--solid" (click)="addInitilaReportData()"
            [disabled]="options.invalid">Generate Report</button>
    </div>

</div>